/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fix_Event_OverlapInputs */



/**
* | output |
* | --- |
* | "Fix Event Overlap" |
*
* @param {Fix_Event_OverlapInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const fix_event_overlap = /** @type {((inputs?: Fix_Event_OverlapInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fix_Event_OverlapInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Corriger le chevauchement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ereignisüberlappung beheben")
	if (locale === "it") return /** @type {LocalizedString} */ ("Correggi sovrapposizione eventi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Исправление наложения событий")
	if (locale === "es") return /** @type {LocalizedString} */ ("Corregir la superposición de eventos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("修复事件重叠")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントの重複を修正")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट ओवरलैप को ठीक करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Corrigir sobreposição de eventos")
	return /** @type {LocalizedString} */ ("Fix Event Overlap")
});